import { render, staticRenderFns } from "./BSelectOrderStatus.vue?vue&type=template&id=20b41b16&scoped=true"
import script from "./BSelectOrderStatus.vue?vue&type=script&lang=js"
export * from "./BSelectOrderStatus.vue?vue&type=script&lang=js"
import style0 from "./BSelectOrderStatus.vue?vue&type=style&index=0&id=20b41b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b41b16",
  null
  
)

export default component.exports